var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"none"},attrs:{"src":"/chat/?origin=https://chatgpt-worker.entrack-plataforma.workers.dev"}})
}
var staticRenderFns = []

export { render, staticRenderFns }